<template>
  <b-card>
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="lg"
      :opacity=".7"
    >
      <ValidationObserver
        v-if="!loading"
        ref="form"
      >
        <Form
          :doctor-review-data.sync="formData"
          :cities-list="citiesList"
          :clinic-options.sync="clinicOptions"
          @formSubmit="doFormSave"
        />
      </ValidationObserver>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import _ from 'lodash'
import axiosIns from '@/libs/axios'
import store from '@/store'
import { FormDataConverter } from '@/mixins/formData'
import Form from './Form.vue'

const emptyFormData = Object.freeze({
  id: null,
  doctor_id: null,
  description: '',
  status: null,
  type: null,
  rating: null,
  rating_confidence: null,
  rating_competence: null,
  rating_punctuality: null,
  rating_question: null,
  ip_address: null,
  user_agent: null,
  doctor: null,
})

export default {
  name: 'DoctorsReviewsUpdate',
  components: {
    BCard,
    BOverlay,
    Form,
  },
  metaInfo: {
    title: 'Редактрование отзыва врача',
  },
  data() {
    return {
      formData: _.cloneDeep(emptyFormData),
      loading: true,
      serverErrors: {},
      clinicOptions: [],
      selectedOptions: [],
      citiesList: [],
    }
  },
  mounted() {
    const promises = []
    promises.push(() => this.doLoadCities())
    promises.push(() => this.doLoadDoctorReview())

    this.loadingPromise(promises)
  },
  beforeDestroy() {
    store.commit('app/UPDATE_CURRENT_PAGE_TITLE', null)
  },
  methods: {
    async doFormSave() {
      this.loading = true
      this.formData.status = 1

      const formData = new FormDataConverter(this.formData)

      try {
        const res = await axiosIns({
          method: 'POST',
          url: `/doctor_reviews/${this.$route.params.id}/update`,
          data: formData.getData(),
        })
        this.loading = false
        if (res.data.status === 'success') {
          await this.$router.push({ name: 'doctors-reviews' })
          this.sendToast({
            title: 'Успех!',
            icon: 'CheckCircleIcon',
            text: 'Отзыва врача успешно обновлен!',
            variant: 'success',
          })
        }
      } catch (error) {
        this.loading = false
        if (error.response.status === 500) {
          this.sendToast({
            title: 'Ошибка!',
            icon: 'AlertCircleIcon',
            text: 'Ошибка на сервере, попробуйте еще раз!',
            variant: 'danger',
          })
        }
        if (error.response.status === 422) {
          this.serverErrors = error.response.data.data
          this.$refs.form.setErrors(this.serverErrors)
          this.sendToast({
            title: 'Ошибка!',
            icon: 'AlertCircleIcon',
            text: 'Не все поля заполнены!',
            variant: 'danger',
          })
        }
      }
    },
    async doLoadDoctorReview() {
      const response = await axiosIns({
        method: 'GET',
        url: `/doctor_reviews/${this.$route.params.id}/show`,
      })

      this.formData = _.merge(this.formData, response.data.data)

      return response
    },
    async doLoadCities() {
      const response = await axiosIns({
        method: 'GET',
        url: '/cities/options',
      })

      this.citiesList = response.data.data

      return response
    },
    loadingPromise(promises) {
      const onlyPromises = []
      this.loading = true

      // Если это функции на обновление фильтров и тп, то запускаем их
      promises.forEach(fn => {
        if (typeof fn === 'function') {
          onlyPromises.push(fn())
        } else {
          onlyPromises.push(fn)
        }
      })

      Promise.all(onlyPromises)
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>
